<div class="flex flex-wrap justify-{{ position }} text-center  {{ gap }}">
  @for (value of ourValues; track value; let i = $index) {
    <div
      (mouseover)="hovering[i] = true"
      (mouseout)="hovering[i] = false"
      [ngClass]="{ 'mb-4': paddingBottom, 'bg-white': backgroudColor }"
      class=" {{
        width
      }}   p-5 items-center flex flex-col bg-lightGrayish border-b-2 transition-all hover-gradient border-[#e6ae48] hover:text-white"
    >
      @if (value.imgSrc) {
        <img
          class="z-10 w-8 pt-1 pb-4"
          [src]="hovering[i] ? value.imgSrc + '-white.svg' : value.imgSrc + '.svg'"
          [alt]="value.imgAlt"
        />
      }
      <p class="z-10 pb-2 text-sm font-bold lg:text-lg">{{ value.title }}</p>
      <span class="z-10 text-xs lg:text-base">
        {{ value.description }}
      </span>
    </div>
  }
</div>
